export default __webpack_public_path__ + "static/media/harbolkick-category-lifestyles.3189c54a.png";